import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ENTRYPOINT } from '@core/endpoint';
import { Pagination } from '@core/interface';

const OVERVIEW_URL = `${ENTRYPOINT}jobs/overview/`;
const JOB_EXPORT_URL = `${ENTRYPOINT}jobs/job_export/`;
const EMPLOYEE_EXPORT_URL = `${ENTRYPOINT}jobs/employee_export/`;
const TERRITORY_EXPORT_URL = `${ENTRYPOINT}jobs/territory_export/`;
const SEEDING_EXPORT_URL = `${ENTRYPOINT}seeding_cycles/seeding_export/`;

export interface OverviewRequest {
  assigned_to: number;
  date_done: Date;
  type: number;
  value: number;
  unit: string;
  time_spent: string;
  job: string;
  notes: string;
  job_title: string;
  report: any | null;
}

export interface Overview extends OverviewRequest {
  id: number;
}

export interface OverviewFilters {
  assignedTo?: number[];
  startDate?: Date | null;
  endDate?: Date | null;
  type?: number[];
  offset?: number;
  limit?: number;

  //for download
  ids?: number[];
}

export type ExportType = 'darbu' | 'darbinieku' | 'teritoriju' | 'sejumu';

@Injectable({
  providedIn: 'root',
})
export class OverviewService {
  private readonly http = inject(HttpClient);

  setParams(filters: OverviewFilters) {
    let params = new HttpParams();

    if (filters.assignedTo && filters.assignedTo?.length > 0) {
      if (filters.assignedTo.length === 1) {
        params = params.set('assigned_to', filters.assignedTo[0]);
      } else {
        params = params.set('assigned_to__in', filters.assignedTo.join(','));
      }
    }

    // resource types
    if (filters.type && filters.type.length > 0) {
      if (filters.type.length === 1) {
        params = params.set('type', filters.type[0]);
      } else {
        params = params.set('type__in', filters.type.join(','));
      }
    }

    // date filters
    if (filters.startDate) {
      params = params.set(
        'date_after',
        filters.startDate.toLocaleDateString('en-CA'), //NEED TO HAVE CANADIAN LOCALE FORMAT ISO WILL RUIN THE TIME BECAUSE OF THE TIMEZONE
      );
    }
    if (filters.endDate) {
      params = params.set(
        'date_before',
        filters.endDate.toLocaleDateString('en-CA'), //NEED TO HAVE CANADIAN LOCALE FORMAT ISO WILL RUIN THE TIME BECAUSE OF THE TIMEZONE
      );
    }

    return params;
  }

  loadOverview(filters?: OverviewFilters): Observable<Pagination<Overview>> {
    let params = new HttpParams();

    if (filters) {
      params = this.setParams(filters);

      //pagination
      if (filters.offset) {
        params = params.set('offset', filters.offset);
      }
      if (filters.limit) {
        params = params.set('limit', filters.limit);
      }
    }
    return this.http.get<Pagination<Overview>>(OVERVIEW_URL, { params });
  }

  exportReport(
    filter: OverviewFilters,
    exportType: ExportType = 'darbu',
  ): Observable<Blob> {
    let params = new HttpParams();
    if (filter.ids && filter.ids.length > 0) {
      if (filter.ids.length === 1) {
        params = params.set('id', filter.ids[0]);
      } else {
        params = params.set('id__in', filter.ids.join(','));
      }
    } else {
      params = this.setParams(filter);
    }
    const url = this.getUrl(exportType);
    return this.http.get(url, { params, responseType: 'blob' });
  }

  private getUrl(exportType: ExportType) {
    switch (exportType) {
      case 'darbu':
        return JOB_EXPORT_URL;
      case 'darbinieku':
        return EMPLOYEE_EXPORT_URL;
      case 'teritoriju':
        return TERRITORY_EXPORT_URL;
      case 'sejumu':
        return SEEDING_EXPORT_URL;
      default:
        return JOB_EXPORT_URL;
    }
  }
}
